import { TileRadioGroup } from '@ai-tutor/ui';

import type { UserRole } from '@/lib/api-client';

import { ROLE_OPTIONS } from './onboarding-config';

interface RoleSelectorProps {
  value?: UserRole | null;
  onChange: (role: UserRole) => void;
  /** Overridden by Settings, which asks the same question differently. */
  label?: string;
  /** For the Settings card, which already renders its own heading. */
  labelHidden?: boolean;
  /** Id of the "please pick one" message, when onboarding is showing it. */
  errorId?: string;
  containerRef?: React.Ref<HTMLDivElement>;
}

/**
 * The role question: `TileRadioGroup` bound to `ROLE_OPTIONS`.
 *
 * The generic grid lives in `@ai-tutor/ui`; this is the Xonera-specific half —
 * the option set, the two-column shape they were written for, the default
 * wording, and the `null → undefined` normalisation the profile API's nullable
 * role needs. Shared by `RoleStep` and the Settings role card so those two can
 * never drift on any of it.
 */
export function RoleSelector({
  value,
  onChange,
  label = 'Which best describes you?',
  labelHidden = false,
  errorId,
  containerRef,
}: RoleSelectorProps) {
  return (
    <TileRadioGroup
      label={label}
      labelHidden={labelHidden}
      options={ROLE_OPTIONS}
      value={value ?? undefined}
      onChange={onChange}
      columns={2}
      errorId={errorId}
      containerRef={containerRef}
    />
  );
}
